import request from '@/utils/request';

export const taskApi = {
  // 列表
  taskList (params) {
    return request({
      url: '/task/list',
      method: 'get',
      params
    });
  },
  // 设置已读
  taskRead (data) {
    return request({
      url: '/task/read',
      method: 'put',
      data
    });
  },
  // 设置全部已读
  taskReadAll () {
    return request({
      url: '/task/read/all',
      method: 'put'
    });
  },
  // 删除任务
  task (data) {
    return request({
      url: '/task',
      method: 'DELETE',
      data
    });
  },
  // 删除全部任务
  taskAll () {
    return request({
      url: '/task/all',
      method: 'DELETE'
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/workbench/task.js